import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IStore } from "redux/store";
import reportActions from "redux/app/report/actions";
import reportSelectors from "redux/app/report/selectors";
import moment from "moment";
import Biofouling2Table from "./_elements/Biofouling2Table";

function Biofouling2() {
	const dispatch = useDispatch();
	const [yearMonth, setYearMonth] = useState(moment().format("YYYY-MM"));

	const reportStore = useSelector((store: IStore) =>
		reportSelectors._getStore(store),
	);
	const isLoading =
		reportSelectors.jobToLoadBiofouling2Data(reportStore).isLoading;

	useEffect(() => {
		dispatch(reportActions.commands.biofouling2FleetDataLoad(yearMonth));
	}, [dispatch, yearMonth]);

	return (
		<div className="bg-white m-2 rounded-lg h-[calc(100vh-98px)] overflow-y-auto">
			<div className="px-5 pb-0 py-8">
				<div className="flex items-center">
					<span
						title="go back"
						onClick={() => window?.history?.back()}
						className="bp3-icon bp3-icon-arrow-left text-lg mr-3 cursor-pointer"
					/>
					<h2 className="text-xl font-medium">Biofouling-2 Usage</h2>
				</div>
				<div className="flex items-center">
					<div className="mt-4 ml-3 pl-4 min-w-28 md:w-56">
						<input
							type="month"
							className="p-1 border border-gray-300 rounded-sm shadow-sm bg-gray-100 text-sm"
							value={yearMonth}
							onChange={(e) => setYearMonth(e.target.value)}
						/>
					</div>
				</div>
			</div>
			{isLoading ? (
				<div className="flex justify-center mt-20">Loading...</div>
			) : (
				<Biofouling2Table />
			)}
		</div>
	);
}

export default Biofouling2;
